import { apiUrl, getList, exportData } from './apiUtils';
import type { ApiListParamsWithUnderscores, ApiExportParams } from '../types/api/listParams';
import type { ListApiResponse } from '../types/apiResponse';

const baseUrl = apiUrl + '/metrics/';

export function gameKeys(
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<unknown>> {
  return getList(`${baseUrl}keys/games`, params);
}

export function gameKeysWorkflow(
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<unknown>> {
  return getList(`${baseUrl}keys/games/workflow`, params);
}

export function exportGameKeysData(params: ApiExportParams): Promise<void> {
  return exportData(`${apiUrl}/export/metrics/keys/games`, 'gameName', params);
}

export function keyPools(
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<unknown>> {
  return getList(`${baseUrl}keys/pools`, params);
}

export function exportKeyPoolsData(params: ApiExportParams): Promise<void> {
  return exportData(`${apiUrl}/export/metrics/keys/pools`, 'gameName', params);
}
